<div class="col-md-12">
    <h3 class="">Set Variance Threshold</h3>  
    <hr style="margin: 0;border: lightgray solid 0.5px; ">
    <br />
    <div class="panel panel-primary"  >
      <div class="panel-heading">Enter Threshold</div>
      <div class="panel-body">
          <div class="form">
                  <form name="form" (ngSubmit)="f.form.valid && OnSubmit()" #f="ngForm"  novalidate>
              <div class="form-group row">
                  <div class="col-sm-4">
                      <input  numeric numericType="decimal" class="form-control" placeholder="Threshold" name="ThresholdAmt"  [(ngModel)]="threshold" #ThresholdAmt="ngModel"
                      [ngClass]="{ 'is-invalid': f.submitted && ThresholdAmt.invalid }" required>
                      <div *ngIf="f.submitted && ThresholdAmt.invalid" class="invalid-feedback invalid-display">
                              <div *ngIf="ThresholdAmt.errors?.['required']">*Threshold Amount is required</div>
                      </div>
                  </div>
                  <div>
                      <button class="btn btn-primary ">Set Threshold</button>  
                  </div>
             
              </div>
          </form>
          </div>
    </div>
  </div>
  <br>
  <table class="table table-bordered">
      <thead>
          <tr>
              <th scope="col">Threshold</th>
              <th scope="col">From Date</th>
              <th scope="col" >To Date</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor ="let thrs of thresholdList">
              <td>{{thrs.Threshold_Amount| currency}}</td>
              <td>{{thrs.FromDate | date}}</td>
              <td>{{thrs.ToDate |date}}</td>
      </tr>
      </tbody>
      
  </table>
  </div>
  